export function isInvalidBid(value = '', prevValue, min, max) {
  return (
    value > max ||
    value < min ||
    +value === 0 ||
    Number.isNaN(+value) ||
    value < 0 ||
    value == prevValue ||
    value.toString().startsWith('.')
  );
}

export function isBidErrorShown(value = '', min, max) {
  return (
    value > max ||
    (value < min &&
      value.toString() !== '0' &&
      value.toString() !== '0.' &&
      value.toString() !== '0.0') ||
    value.toString() === '0.000'
  );
}

export function trimDecimal(num, isCpm = false) {
  const digits = isCpm ? 3 : 2;
  const parts = num.toString().split('.');

  if (parts.length === 2 && parts[1].length > digits) {
    const trimmedEnd = parts[1].slice(0, digits);
    // const start = parts[0] || 0;
    const start = parts[0] || '';
    return `${start}.${trimmedEnd}`;
  }

  // if (num.toString().startsWith('.') && parts.length === 2 && parts[1] !== '') return '0' + num;
  return num;
}
